<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils :key="pageTitle" :title="pageTitle"/>

            <div class="container-fluid-grid">
                <div class="row">
                    <div class="col-12">
                        <div class="chart-container">
                            <div class="t-c" v-if="search && search.income && search.outcome">
                                <div class="progress">
                                    <span class="done">realizado R$ {{search.income.total_realized | formatMoney}}</span>
                                    <span class="start">RECEITAS</span>
                                    <span class="end">previsto R$ {{search.income.total_all | formatMoney}}</span>
                                    <span class="pgr income" :style="{width: `${search.income.percent}%`}">{{search.income.percent}}%</span>
                                </div>
                                <div class="progress">
                                    <span class="done">realizado R$ {{search.outcome.total_realized | formatMoney}}</span>
                                    <span class="start">GASTOS</span>
                                    <span class="end">previsto R$ {{search.outcome.total_all | formatMoney}}</span>
                                    <span class="pgr outcome" :style="{width: `${search.outcome.percent}%`}">{{search.outcome.percent}}%</span>
                                </div>
                            </div>
                            <div class="t-c">
                                <h5>Últimos 6 Meses</h5>
                                <ChartJs type="doughnut"
                                         style="background-color: rgba(255,255,255,.2)"
                                         width="280"
                                         height="120"
                                         :data="dataSix"
                                         :options="options"/>
                            </div>
                            <div class="t-c">
                                <h5>Últimos 3 Meses</h5>
                                <ChartJs type="doughnut"
                                         style="background-color: rgba(255,255,255,.2)"
                                         width="280"
                                         height="120"
                                         :data="dataTree"
                                         :options="options"/>
                            </div>
                            <div class="t-c">
                                <h5 v-if="search.last_year_ago_tree_months">3 Meses ({{search.last_year_ago_tree_months.start_date | formatDate('MMM/YYYY')}} à {{search.last_year_ago_tree_months.end_date | formatDate('MMM/YYYY')}})</h5>
                                <ChartJs type="doughnut"
                                         style="background-color: rgba(255,255,255,.2)"
                                         width="280"
                                         height="120"
                                         :data="dataYearAgoTree"
                                         :options="options"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ibox type="tab_right">
                <template v-slot:title v-if="!$appUtils.isMobile()">
                    <h5 v-if="!$appUtils.isMobile()"><svg-icon icon="cash-register"/>Lançamentos</h5>
                </template>

                <template v-slot:tabs>
                    <Tabs :tabs="tabs" @onTabSelected="onTabSelected"/>
                </template>

                <template v-slot:content>
                    <div class="container-fluid-grid">
                        <div class="row">
                            <div class="col-12 filters-container">
                                <MonthNav :month.sync="currentMonthYear" v-if="$appUtils.isDesktop()"/>
                                <select class="form-control form-control inline month"
                                        @change="changeMonthYear"
                                        v-model="selectedMonth">
                                    <option v-for="(m,idx) in months" :key="idx" :value="m.format('MM')">{{m.format('MMMM')}}</option>
                                </select>

                                <select class="form-control form-control year"
                                        @change="changeMonthYear"
                                        v-model="selectedYear">
                                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                </select>

                                <button type="button"
                                        class="btn"
                                        :class="`btn-${tabs[currentTab].type.replace(/_/, '-')}`"
                                        v-if="$appUtils.isDesktop()"
                                        @click="addEntity">
                                    <svg-icon icon="plus"/>
                                </button>

                                <div class="totals" v-if="filteredEntries.length > 0">
                                    <div class="paid">Pago: <span ref="totalPaid"></span></div>
                                    <div class="foreseen">Falta: <span ref="totalNotPaid"></span></div>
                                    <div class="total">Total: <span ref="total"></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="$appUtils.isDesktop()">
                            <div class="col-12">
                                <Loading :visible="searching"/>
                                <table class="table table-sm table-bordered table-hover">
                                    <thead class="thead-center" :class="tabs[currentTab].type">
                                    <tr>
                                        <th style="width: 40px">
                                            <select v-model="entriesFilter.paid" class="ipt-transp c-w w-all not-outline">
                                                <option value="all">Todos</option>
                                                <option :value="true">Pagos</option>
                                                <option :value="false">Não pagos</option>
                                            </select>
                                        </th>
                                        <th class="t-c f-w-700" style="width: 20%">
                                            <input type="search" v-model="entriesFilter.identifier" class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c" placeholder="Identificador">
                                        </th>
                                        <th class="t-c f-w-700" style="width: 40%">
                                            <input type="search" v-model="entriesFilter.customer" class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c" placeholder="Cliente/Fornecedor">
                                        </th>
                                        <th class="t-c f-w-700" style="min-width: 125px">
                                            <select v-model="entriesFilter.emittedOrScheduled" class="ipt-transp c-w w-all not-outline">
                                                <option v-for="k in Object.keys(emittedOrScheduledDts)" :key="k" :value="k">{{emittedOrScheduledDts[k]}}</option>
                                            </select>
                                        </th>
                                        <th class="t-c f-w-700" style="min-width: 95px">
                                            <select v-model="entriesFilter.paidAt" class="ipt-transp c-w w-all not-outline">
                                                <option v-for="k in Object.keys(paymentDates)" :key="k" :value="k">{{paymentDates[k]}}</option>
                                            </select>
                                        </th>
                                        <th class="t-c f-w-700" style="min-width: 120px">
                                            <input type="search" v-model="entriesFilter.value" class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c" placeholder="Valor">
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="fm in filteredEntries" :key="fm.id" class="c-p line-item">
                                        <td class="t-c">
                                            <svg-icon :svg-class="['svg-paid', fm.paid ? 'yes' : 'no']"
                                                      :icon="fm.paid ? 'thumbs-up' : 'thumbs-down'"/>
                                        </td>
                                        <td class="ellipsis" @click="showModal(fm)">{{fm.identifier}}</td>
                                        <td class="ellipsis" @click="showModal(fm)">{{fm.customer.name}}</td>
                                        <td class="t-c" @click="showModal(fm)">{{(showColumnEmitted ? fm.emitted_at : fm.scheduled_to) | formatDate}}</td>
                                        <td class="t-c" @click="showModal(fm)">{{fm.paid_at | formatDate}}</td>
                                        <td class="t-r f-w-700 o-x-h o-h p-r">
                                            {{(fm.movement_type === 'people' ? fm.calculated_total : fm.value) | formatMoney}}

                                            <div class="actions btn-group btn-group-xs">
                                                <button type="button"
                                                        class="btn btn-theme-1 btn-xs c-w"
                                                        @click="showModal(fm, 'clone')"
                                                        title="Clonar">
                                                    <svg-icon icon="clone"/>
                                                </button>
                                                <button type="button"
                                                        class="btn btn-danger btn-xs"
                                                        @click="finMovToRemove = fm"
                                                        title="Remover">
                                                    <svg-icon icon="trash-alt"/>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="$appUtils.isMobile()">
                        <div class="t-c" v-if="searching">
                            <svg-icon icon="sync" class="refresh load-more-crud"/>
                        </div>
                        <div v-else v-for="fm in filteredEntries" :key="fm.id" class="list-card">
                            <span class="ident ellipsis">{{fm.identifier}}</span>
                            <span class="value f-w-700">{{fm.calculated_total | formatMoney}}</span>
                            <span class="emit">Emissão<br/>{{fm.emitted_at | formatDate}}</span>
                            <span class="sched">Agendado<br/>{{fm.scheduled_to | formatDate}}</span>
                            <span class="paid">Pago<br/>{{fm.paid_at | formatDate}}</span>
                            <span class="cust ellipsis">{{fm.customer.name}}</span>

                            <div class="act">
                                <button type="button"
                                        class="btn btn-sm"
                                        title="Editar"
                                        @click="showModal(fm)">
                                    <svg-icon icon="pencil-alt"/>
                                </button>

                                <button type="button"
                                        class="btn btn-sm"
                                        title="Clonar"
                                        @click="showModal(fm, 'clone')">
                                    <svg-icon icon="clone"/>
                                </button>

                                <button type="button"
                                        class="btn btn-sm"
                                        title="Remover"
                                        @click="finMovToRemove = fm">
                                    <svg-icon icon="trash-alt"/>
                                </button>
                            </div>
                        </div>
                        <div v-if="filteredEntries.length === 0">
                            <h5 class="t-c">Não há lançamentos até o momento.</h5>
                        </div>
                    </div>
                    <transition name="fab-menu" mode="out-in">
                        <fab type="button"
                             icon="plus"
                             v-if="$appUtils.isMobile()"
                             size="normal"
                             @click="addEntity"
                             :color="tabs[currentTab].type.replace(/_/, '-')"/>
                    </transition>
                </template>
            </ibox>


            <modal size="large"
                   v-if="finMovToRemove != null"
                   id="ModalFinancialMovement">

                <template v-slot:header>
                    <h3 class="title">{{$t('common.destroyItemTitle')}}</h3>
                </template>

                <template v-slot:body>
                    <div slot="body">
                        <div v-if="finMovToRemove.group_uuid">
                            O lançamento atual é um lançamento recorrente. Como você deseja remover?
                        </div>
                        <div v-else>{{$t('common.destroyItemMessage')}}</div>
                    </div>
                </template>
                <template v-slot:footer>
                    <button type="button"
                            v-if="finMovToRemove.group_uuid"
                            @click="destroyItem"
                            class="btn btn-sm btn-danger">
                        <span class="f-w-700 circle">1</span> Somente Selecionado
                    </button>

                    <button type="button"
                            v-if="finMovToRemove.group_uuid"
                            @click="destroyMultiple('start')"
                            class="btn btn-sm btn-danger">
                        <span class="f-w-700 circle">2</span> Este e os Próximos
                    </button>

                    <button type="button"
                            v-if="finMovToRemove.group_uuid"
                            @click="destroyMultiple('all')"
                            class="btn btn-sm btn-danger">
                        <span class="f-w-700 circle">3</span> Todos Vinculados
                    </button>

                    <button type="button"
                            v-else
                            @click="destroyItem"
                            class="btn btn-sm btn-danger">
                        <svg-icon icon="check"/>
                        Sim
                    </button>
                    <button type="button"
                            @click="() => {finMovToRemove = null}"
                            class="btn btn-sm btn-dark">
                        <svg-icon icon="times"/>
                        Fechar
                    </button>
                </template>
            </modal>
        </template>
    </DefaultTmpl>

</template>

<script>
    import {EventBus} from "../../utils/EventBus";
    import {formatMoney} from '@/utils/Utils'
    import {createNamespacedHelpers} from 'vuex'
    import Tabs from "../../components/particles/Tabs";
    import Fab from "../../components/particles/Fab";
    import ChartJs from "../../components/particles/ChartJs";
    import DefaultTmpl from "../../templates/DefaultTmpl";
    import MonthNav from './MonthNav'
    import {isEmpty, formatDate} from "../../utils/Utils";
    import { CountUp } from 'countup.js'

    import dayjs from 'dayjs'
    import Loading from "../../components/particles/Loading";

    const {mapGetters, mapActions} = createNamespacedHelpers('financial_movements');

    const DATE_FORMAT = 'YYYY-MM-DD';

    const buildDateOptions = (dates, filter = {}) => {
        let array = [];

        dates.filter(d => !isEmpty(d)).forEach(d => {
            if (array.indexOf(d) === -1) array.push(dayjs(d))
        });

        array = array.sort((dt1, dt2) => {
            return dt1.isSame(dt2) ? 0 : dt1.isBefore(dt2) ? -1 : 1;
        });

        array.forEach(a => {
            filter[a] = formatDate(a)
        });

        return array;
    };

    const countUpOpt = {
        startVal: 0,
        decimalPlaces: 2,
        duration: .5,
        separator: '.',
        decimal: ',',
    };

    const moldEntriesFilter = {
        paid: 'all',
        identifier: null,
        customer: null,
        emittedOrScheduled: 'all',
        paidAt: 'all',
        value: null,
    };

    export default {
        name: "FinancialMovementsSearch",
        components: {
            Loading,
            Fab, Tabs, MonthNav, DefaultTmpl, ChartJs
        },
        data() {
            return {
                entriesFilter: {...moldEntriesFilter},
                isOpenFabMenu: false,
                searching: false,
                dataSix: {
                    datasets: [{
                        data: [0, 0],
                        backgroundColor: [
                            '#56b349',
                            '#db2b2f'
                        ],
                        label: 'Realizado'
                    }],
                    labels: [
                        'Receitas',
                        'Despesas'
                    ]
                },
                dataTree: {
                    datasets: [{
                        data: [0, 0],
                        backgroundColor: [
                            '#56b349',
                            '#db2b2f'
                        ],
                        label: 'Realizado'
                    }],
                    labels: [
                        'Receitas',
                        'Despesas'
                    ]
                },
                dataYearAgoTree: {
                    datasets: [{
                        data: [0, 0],
                        backgroundColor: [
                            '#56b349',
                            '#db2b2f'
                        ],
                        label: 'Realizado'
                    }],
                    labels: [
                        'Receitas',
                        'Despesas'
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        display: true,
                        position: 'right'
                    },
                    title: {
                        display: false
                    },
                    animation: {
                        animateScale: false,
                        animateRotate: true
                    },
                    tooltips: {
                        callbacks: {
                            title: function(tooltipItems, data) {
                                return data.datasets[tooltipItems[0].datasetIndex].label;
                            },
                            label(tooltipItem, data) {
                                return `${data.labels[tooltipItem.index]} R$ ${formatMoney(data.datasets[0].data[tooltipItem.index])}`;
                            }
                        }
                    }
                },
                tabs: [{
                    icon: 'plus-circle',
                    label: 'Recebíveis',
                    type: 'income',
                    active: true
                }, {
                    icon: 'minus-circle',
                    label: 'Despesas Variáveis',
                    type: 'variable_expenses',
                    active: false
                }, {
                    icon: 'minus-circle',
                    label: 'Despesas Fixas',
                    type: 'fixed_expenses',
                    active: false
                }, {
                    icon: 'minus-circle',
                    label: 'Impostos',
                    type: 'taxes',
                    active: false
                }],
                finMovToRemove: null,
                currentTab: 0,
                currentMonthYear: dayjs().startOf('month').format(DATE_FORMAT),
                months: [],
                years: [],
                selectedMonth: dayjs().startOf('month').format('MM'),
                selectedYear: parseInt(dayjs().startOf('month').format('YYYY'))
            }
        },
        methods: {
            ...mapActions(['filter', 'destroy']),
            destroyItem() {

                const self = this;
                this.destroy(this.finMovToRemove.id)
                    .then(() => {
                        self.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name);
                        self.doFilter();
                        self.finMovToRemove = null
                    })
                    .catch(err => {
                        self.$snotify.error(this.$t('common.destroyItemError'), this.$appStorage.getUser().name);
                        console.error(err);
                    })
            },
            destroyMultiple(type) {
                this.$appHttp.delete(`/v1/financial_movements/${this.finMovToRemove.id}/${type}`)
                    .then(() => {
                        this.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name);
                        this.doFilter();
                        this.finMovToRemove = null
                    })
                    .catch(err => {
                        this.$snotify.error(this.$t('common.destroyItemError'), this.$appStorage.getUser().name);
                        console.error(err);
                    })
            },
            showModal(entity, mode = null) {
                EventBus.showFinMov(() => {
                    this.doFilter();
                }, {entity: entity, mode: mode});
            },
            onTabSelected(tab){
                this.currentTab = tab.index;
                this.$router.push({query: {...this.$router.currentRoute.query, movement_type: this.tabs[this.currentTab].type}})
            },
            buildMonthYears() {
                if (this.months.length === 0)
                    for(let i = 1; i <= 12; i++)
                        this.months.push(dayjs(`2019-${i}-01`));

                const start = parseInt(dayjs(this.currentMonthYear, DATE_FORMAT).subtract(5, 'year').format('YYYY'));

                this.years = [];
                for(let i = 0; i < 10; i++)
                    this.years.push(start + i);
            },
            changeMonthYear() {
                this.$router.push({query: {year_month: `${this.selectedYear}-${this.selectedMonth}-01`}})
            },
            setActiveTabByType(type) {
                this.tabs.filter(t => t.active)[0].active = false;

                for(let i = 0; i < this.tabs.length; i++) {
                    if (this.tabs[i].type === type) {
                        this.tabs[i].active = true;
                        this.currentTab = i;
                        break
                    }
                }
            },
            addEntity() {
                const date = dayjs(this.currentMonthYear).set('date', dayjs().date()).format('DD/MM/YYYY');
                const type = this.tabs[this.currentTab].type;

                const entity = {
                    movement_type: type,
                    emitted_at: date,
                    scheduled_to: type !== 'income' ? date : null
                };

                this.showModal(entity);
            },
            doFilter() {
                this.searching = true;
                const params = new URLSearchParams({date: this.currentMonthYear, movement_type: this.tabs[this.currentTab].type});
                this.filter(`/v1/financial_movements?${params.toString()}`)
                    .then(data => {

                        new CountUp(this.$refs.totalPaid, parseFloat(data.paid), countUpOpt).start();
                        new CountUp(this.$refs.totalNotPaid, parseFloat(data.not_paid), countUpOpt).start();
                        new CountUp(this.$refs.total, parseFloat(data.total), countUpOpt).start();

                        this.entriesFilter = {...moldEntriesFilter};

                        let newData = {...this.dataTree};
                        newData.datasets[0].data[0] = data.last_tree_months.income;
                        newData.datasets[0].data[1] = data.last_tree_months.outcome;

                        this.dataTree = {...newData};

                        newData = {...this.dataSix};
                        newData.datasets[0].data[0] = data.last_six_months.income;
                        newData.datasets[0].data[1] = data.last_six_months.outcome;

                        this.dataSix = {...newData};

                        newData = {...this.dataYearAgoTree};
                        newData.datasets[0].data[0] = data.last_year_ago_tree_months.income;
                        newData.datasets[0].data[1] = data.last_year_ago_tree_months.outcome;

                        this.dataYearAgoTree = {...newData};
                    })
                    .catch(({response}) => {
                        this.$appUtils.vibrate();
                        this.$snotify.error(this.$t(response.status === 403 ? 'common.403' : 'common.generalHttpError'), this.$appStorage.getUser().name)
                        console.error(response);
                    })
                    .finally(() => this.searching = false);
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                const {year_month, movement_type} = to.query;

                if (year_month) {
                    const d = dayjs(year_month, DATE_FORMAT).startOf('month');
                    vm.currentMonthYear = d.format(DATE_FORMAT);
                    vm.buildMonthYears();
                    vm.selectedMonth = d.format('MM');
                    vm.selectedYear = parseInt(d.format('YYYY'));
                } else {
                    const d = dayjs().startOf('month');
                    vm.currentMonthYear = d.format(DATE_FORMAT);
                    vm.buildMonthYears();
                    vm.selectedMonth = d.format('MM');
                    vm.selectedYear = parseInt(d.format('YYYY'));
                }

                if (movement_type) vm.setActiveTabByType(movement_type);

                vm.doFilter();
            });
        },
        beforeRouteUpdate(to, from, next) {
            const {year_month, movement_type} = to.query;
            if (year_month) {
                const d = dayjs(year_month, DATE_FORMAT).startOf('month');
                this.currentMonthYear = d.format(DATE_FORMAT);
                this.buildMonthYears();
                this.selectedMonth = d.format('MM');
                this.selectedYear = parseInt(d.format('YYYY'));
            }

            if (movement_type) this.setActiveTabByType(movement_type);

            this.doFilter();

            next();
        },
        mounted() {
            if (this.$appStorage.userIsProfile(['admin', 'admin_all', 'admin_view'])) {
                this.tabs.push({
                    icon: 'minus-circle',
                    label: 'Colaboradores',
                    type: 'people',
                    active: false
                });
            }

            this.buildMonthYears();
        },
        computed: {
            ...mapGetters(['search']),
            pageTitle() {
                return `${this.tabs[this.currentTab].label} ${dayjs(this.currentMonthYear, DATE_FORMAT).format('MMMM [de] YYYY')}`;
            },
            showColumnEmitted() {
                return /(income|people)/.test(this.tabs[this.currentTab].type)
            },
            filteredEntries() {
                return this.search.entries.filter(e => {
                    const paidCriteria = this.entriesFilter.paid === 'all' || e.paid === this.entriesFilter.paid;
                    const identifierCriteria = (e.identifier || '').containsStr(this.entriesFilter.identifier);
                    const customerCriteria = !e.customer || (e.customer.name || '').containsStr(this.entriesFilter.customer);
                    const emittedCriteria =  this.entriesFilter.emittedOrScheduled === 'all' || dayjs(e[this.showColumnEmitted ? 'emitted_at' : 'scheduled_to']).isSame(this.entriesFilter.emittedOrScheduled);
                    const paidAtCriteria = this.entriesFilter.paidAt === 'all' || dayjs(this.entriesFilter.paidAt).isSame(e.paid_at);
                    const valueCriteria = e.value.containsStr(this.entriesFilter.value);

                    return paidCriteria && identifierCriteria && customerCriteria && emittedCriteria && paidAtCriteria && valueCriteria
                });
            },
            paymentDates() {
                const filter = {'all': 'PAGAMENTO'};
                buildDateOptions(this.search.entries.map(e => e.paid_at), filter);
                return filter
            },
            emittedOrScheduledDts() {
                const filter = {'all': this.showColumnEmitted ? 'EMISSÃO' : 'VENCIMENTO'};
                buildDateOptions(this.search.entries.map(e => e[this.showColumnEmitted ? 'emitted_at' : 'scheduled_to']), filter);
                return filter
            }
        }
    }
</script>

<style scoped lang="scss">
    //@import "../../assets/css/styles";
    @import "../../assets/css/variables";

    .svg-paid {
        width: 1em;
        height: 1em;

        &.yes {
            color: green;
        }

        &.no {
            color: red;
        }
    }


    .thead-center {
        color: #fff;
        transition: background-color .5s ease;
        th {
            transition: border-color .5s ease;
            text-transform: uppercase;
        }

        &.income {
            background-color: $income_main_color;
            th {
                border-color: lighten($income_main_color, 3);
            }
        }
        &.variable_expenses {
            background-color: $variable_expenses_main_color;
            th {
                border-color: lighten($variable_expenses_main_color, 3);
            }
        }
        &.fixed_expenses {
            background-color: $fixed_expenses_main_color;
            th {
                border-color: lighten($fixed_expenses_main_color, 3);
            }
        }
        &.taxes {
            background-color: $taxes_main_color;
            th {
                border-color: lighten($taxes_main_color, 3);
            }
        }
        &.people {
            background-color: $people_main_color;
            th {
                border-color: lighten($people_main_color, 3);
            }
        }
    }

    .list-card {
        display: grid;
        width: 100%;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto;
        grid-template-areas: "ident ident value"  "emit sched paid" "cust cust act";
        grid-gap: 5px;
        font-size: .8em;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .ident{
            grid-area: ident;
        }

        .value {
            grid-area: value;
            text-align: right;
        }

        .emit {
            grid-area: emit;
        }

        .sched {
            grid-area: sched;
            text-align: center;
        }

        .paid {
            grid-area: paid;
            text-align: right;
        }

        .cust {
            grid-area: cust;
        }

        .act {
            grid-area: act;
            text-align: right;

            .btn {
                background-color: #e5e5e5;
                svg {
                    color: #000;
                }
            }

            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
    }

    .circle {
        display: inline-block;
        background-color: #fff;
        border-radius: 50%;
        color: #dc3545;
        width: 1.4em;
        height: 1.4em;
    }

    .progress {
        display: grid;
        grid-template-columns: 1fr 2fr;
        grid-template-rows: .9em;
        grid-template-areas: 'done done' 'start end' 'pgr pgr';

        .done {
            grid-area: done;
            text-align: right;
            font-size: .8em;
        }

        .pgr {
            transition: width .4s ease;
            grid-area: pgr;
            display: inline-block;
            width: 70%;
            height: 1em;
            text-align: center;
            font-size: .8em;
            color: #fff;
            line-height: 1.1em;
            border-radius: .5em;
            overflow: hidden;

            &.income {
                background-color: $income_main_color;
            }
            &.outcome {
                background-color: $fixed_expenses_main_color;
            }
        }

        .start {
            grid-area: start;
            font-size: .8em;
        }

        .end {
            font-size: .8em;
            grid-area: end;
            text-align: right;
        }
    }


    .chart-container {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: auto;
        align-items: center;
        grid-gap: 5px;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .filters-container {
        display: grid;
        grid-template-columns: minmax(400px, 450px) 150px 80px 50px auto;
        grid-template-rows: auto;
        align-items: center;
        grid-gap: 10px;
        padding-bottom: 10px;


        .totals {
            text-align: right;
            font-size: .9em;
            grid-area: totals;

            .paid {
                color: green;
            }

            .foreseen {
                color: red;
            }

            .total {
                font-weight: 700;
                text-transform: uppercase;
            }
        }
    }

    @media only screen and (max-width: 1299px) {
        .progress {
            grid-template-columns: 1fr 2fr;
            grid-template-areas: 'start start' 'done done' 'end end' 'pgr pgr';

            .start {
                font-weight: bold;
            }

            .done, .end {
                text-align: center;
            }
        }

        .chart-container {
            margin-top: 0;
            margin-bottom: 0;
            overflow-x: auto;
            width: calc(100vw - 240px);
            padding-bottom: 20px;

            > div {
                max-width: 300px;
                min-width: 280px;
                display: inline-block;
            }
        }
    }

    @media only screen and (max-width: 576px) {
        .filters-container {
            grid-template-columns: 3fr 2fr 1fr;
            grid-template-areas: 'month year year' 'totals totals totals';

            .month {
                grid-area: month;
            }
            .year {
                grid-area: year;
            }
            .btn {
                grid-area: btn;
            }
        }
        .chart-container {
            width: 100%;
            > div {
                min-width: calc(100vw - 30px);
            }
        }
    }

</style>
